import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

import Control from './basicSelectComponents/Control';
import Menu from './basicSelectComponents/Menu';
import Option from './basicSelectComponents/Option';

const selectStyles = {
  control: provided => ({
    ...provided,
    border: 'solid 1px transparent',
    borderBottomColor: '#CCC',
    borderRadius: 'none',
    boxShadow: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
    color: '#111',
    '&:hover': { border: 'solid 1px transparent', borderBottomColor: '#CCC' }
  }),
  dropdownIndicator: provided => ({
    ...provided,
    svg: { display: 'none' },
    ':after': { content: 'url(/icons/chevron-down-black.svg)' }
  }),
  indicatorSeparator: provided => ({ ...provided, display: 'none' }),
  menu: provided => ({
    ...provided,
    padding: 0,
    margin: '-1px 0 0',
    boxShadow: 'inset 0px 0px 1px 1px #CCC',
    borderRadius: 0
  }),
  menuList: provided => ({ ...provided, padding: 0 }),
  option: (provided, { isSelected, isFocused }) => {
    let backgroundColor = 'transparent';
    if (isFocused) backgroundColor = '#CCC';
    if (isSelected) backgroundColor = 'black !important';

    return {
      ...provided,
      backgroundColor,
      padding: '16px 16px 20px 16px',
      '&:hover': { backgroundColor: '#CCC', cursor: 'pointer' }
    };
  },
  placeholder: provided => ({ ...provided, color: '#8D8D8D' }),
  valueContainer: provided => ({ ...provided, padding: 0 })
};

const cartSelectStyles = {
  control: (provided, { selectProps: { label } }) => ({
    ...provided,
    border: 'solid 1px #E5E5E5',
    borderRadius: '2px',
    boxShadow: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
    color: '#111',
    height: label ? '55px' : '40px',
    paddingLeft: '10px',
    paddingTop: label ? '12px' : 0,
    ':hover': { border: 'solid 1px #E5E5E5' }
  }),
  dropdownIndicator: (provided, { selectProps: { menuIsOpen } }) => {
    let transform = 'none';
    if (menuIsOpen) transform = 'rotate(180deg)';

    return {
      ...provided,
      svg: {
        content: 'url(/icons/chevron-down-black.svg)',
        color: '#111',
        transition: 'all 300ms',
        transform
      }
    };
  },
  indicatorSeparator: provided => ({ ...provided, display: 'none' }),
  menu: provided => ({
    ...provided,
    padding: 0,
    margin: '-1px 0 0',
    boxShadow: 'none',
    border: 'solid 1px #E5E5E5',
    borderRadius: 0,
    zIndex: 3
  }),
  menuList: provided => ({ ...provided, padding: 0 }),
  option: (provided, { isSelected, isFocused }) => {
    let backgroundColor = 'white';
    if (isFocused) backgroundColor = '#F5F5F5';
    if (isSelected) backgroundColor = 'black !important';

    return {
      ...provided,
      backgroundColor,
      cursor: 'pointer',
      padding: '10px',
      ':active': { backgroundColor: '#CCC' }
    };
  },
  placeholder: provided => ({ ...provided, color: '#8D8D8D' }),
  valueContainer: provided => ({ ...provided, padding: 0 })
};

const BasicSelect = ({ name, options, value, placeholder, label, ...rest }) => {
  const reactSelectValue = typeof value === 'string' ? options.find(option => option.value === value) : value;

  return (
    <div className='basicSelect__container body-3'>
      {rest.isCart && label && (
        <label htmlFor={name} className='basicSelect__label pl3-sm pt2-sm text-color-secondary'>
          {label}
        </label>
      )}
      <ReactSelect
        name={name}
        options={options}
        defaultValue={reactSelectValue}
        value={reactSelectValue}
        styles={rest.isCart ? cartSelectStyles : selectStyles}
        placeholder={placeholder}
        label={label}
        components={{
          Control,
          Menu,
          Option
        }}
        {...rest}
      />
    </div>
  );
};

BasicSelect.defaultProps = {
  label: ''
};

BasicSelect.propTypes = {
  ...ReactSelect.propTypes,
  label: PropTypes.string
};

export default BasicSelect;
